document.addEventListener("DOMContentLoaded", function() {
  const initializeFera = () => {
    if (! fera.getRating) return;
    const ratingStars = document.querySelector('.pdp-rating-stars');
    const ratingStarsBg = document.querySelector('.pdp-rating-bg');
    const ratingStarsFg = document.querySelector('.pdp-rating-fg');
    const ratingStarsCount = document.querySelector('.pdp-rating-count');
    if (!ratingStars) return;
    fera.getRating().then((rating) => {
      const { average, count } = rating;
      if (count === 0) return;

      ratingStars.classList.remove('hidden');
      ratingStarsFg.style.width = `${average * 20}%`;
      ratingStarsCount.textContent = `(${count})`;
    });
  };

  const maxAttempts = 50;
  let attemptCount = 0;

  if (fera.getRating) {
    initializeFera();
  } else {
    const feraInterval = setInterval(() => {
      attemptCount++;
      if (typeof fera !== "undefined") {
        clearInterval(feraInterval);
        initializeFera();
      } else if (attemptCount >= maxAttempts) {
        clearInterval(feraInterval);
        console.error("Fera failed to load within the expected time.");
      }
    }, 100);
  }
});
